import { render, staticRenderFns } from "./DataTableLoader.vue?vue&type=template&id=66f354f3&"
import script from "./DataTableLoader.vue?vue&type=script&lang=js&"
export * from "./DataTableLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports